module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Settings-2-a1c61b658c0126688618dd23dfd5f4d4.svg";